import {
    GET_DOCUMENTS_PROPOSAL_PENDING,
    GET_DOCUMENTS_PROPOSAL_FULFILLED,
    GET_DOCUMENTS_PROPOSAL_REJECTED,
  } from "../actions/types";
  
const initialState = {
  data: [],
  loading: false,
  error: false,
};
    
export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DOCUMENTS_PROPOSAL_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_DOCUMENTS_PROPOSAL_FULFILLED:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
      };
    case GET_DOCUMENTS_PROPOSAL_REJECTED:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};